import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  Input,
  OnInit,
  ViewChild
} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { saveAs } from 'file-saver';
import { MomentModule } from 'ngx-moment';
import { BehaviorSubject, merge, Observable, of } from 'rxjs';
import { mergeMap, tap } from 'rxjs/operators';
import { ConfigService } from 'src/app/shared/services/config.service';
import { HlCurrencyPipe } from '../../../shared/pipes/hl-currency.pipe';
import { CustomerService } from '../../../shared/services/customer.service';
import { PreviousHiresDataSource } from './previous-hires-datasource';
@Component({
  selector: 'app-previously-hired-items',
  templateUrl: './previously-hired-items.component.html',
  styleUrls: ['./previously-hired-items.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatTooltipModule,
    MomentModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatIconModule,
    MomentModule,
    MatCheckboxModule,
    ReactiveFormsModule,
    HlCurrencyPipe
  ]
})
export class PreviouslyHiredItemsComponent implements OnInit, AfterViewInit {
  @Input() set customerId(value: number | null) {
    this.currentCustomerId.next(value);
  }

  private currentCustomerId = new BehaviorSubject<number | null>(null);
  dateTimeFormat = ConfigService.dates.longDateTimeFormat;

  dataSource: PreviousHiresDataSource;
  displayedColumns: string[] = [
    'product_name',
    'quantity',
    'item_name',
    'on_hire',
    'off_hire',
    'charge',
    'docket_id',
    'docket_status'
  ];

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  onlyActiveFilter = new FormControl(false);

  private loadingSubject = new BehaviorSubject<Observable<boolean>>(of(true));
  loading$ = this.loadingSubject.asObservable().pipe(mergeMap((obs) => obs));

  constructor(private customerService: CustomerService) {
    this.dataSource = new PreviousHiresDataSource(customerService);
    this.loadingSubject.next(this.dataSource.loading$);
  }

  ngOnInit(): void {
    // Initialize the datasource
  }

  ngAfterViewInit(): void {
    // Set up sorting and pagination
    this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));

    merge(
      this.sort.sortChange,
      this.paginator.page,
      this.onlyActiveFilter.valueChanges,
      this.currentCustomerId.asObservable()
    )
      .pipe(tap(() => this.loadPreviousHiresPage()))
      .subscribe();

    // Initial load of the first page
    if (this.currentCustomerId.value) {
      this.loadPreviousHiresPage();
    }
  }

  loadPreviousHiresPage() {
    if (this.currentCustomerId.value) {
      this.dataSource.loadPreviousHires(
        this.currentCustomerId.value,
        this.paginator,
        this.sort,
        this.onlyActiveFilter.value
      );
    }
  }

  exportToExcel() {
    if (this.currentCustomerId.value) {
      this.customerService
        .exportPreviousHiresToExcel(
          this.currentCustomerId.value,
          this.onlyActiveFilter.value
        )
        .subscribe((blob) => {
          saveAs(blob, `customer-${this.currentCustomerId.value}-hires.xlsx`);
        });
    }
  }
}
